import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { ContactsProvider } from './context/ContactsContext';
import { MessagesProvider } from './context/MessagesContext';
import { UISettingsProvider } from './context/UISettingsContext';
import { MainApp } from './components/MainApp';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <ContactsProvider>
        <MessagesProvider>
          <UISettingsProvider>
            <MainApp />
          </UISettingsProvider>
        </MessagesProvider>
      </ContactsProvider>
    </AuthProvider>
  );
}

export default App;